import React from 'react';
import { Table, TableBody, TableRow } from '@material-ui/core';
import { Icon } from '@nearst/ui';

import { useInventory } from '@services/stock';
import { useShop } from '@services/ShopProvider';
import { useIsChain } from '@utils/useIsChain';

import { Pills } from './TableCells/Status';
import { usePrice } from './TableCells/Price';
import { useQuantity } from './TableCells/Quantity';
import { ItemCell } from './TableCells/Item';
import { useHandleInventoryClick } from './TableCells/NavigationCell';

import styles from './InventoryViewer.module.scss';

const MobileCell = ({ row, setStockLevelsBarcode }) => {
	const isChain = useIsChain();
	const price = usePrice(row);
	const quantity = useQuantity(row, () => setStockLevelsBarcode(row.barcode));
	return (
		<div className={styles.summary}>
			<ItemCell row={row}>
				<p className={styles.greyText}>
					{price}, {quantity}
					{!isChain && ' in stock'}
				</p>
				<p className={styles.greyText}>{row.category_titles?.[0]}</p>
				{row.delivery_categories?.length > 0 && <p className={styles.greyText}>{row.delivery_categories.join(', ')}</p>}
				<Pills row={row} />
			</ItemCell>

			{!isChain && <Icon className={styles.summaryIcon}>chevron_right</Icon>}
		</div>
	);
};

const MobileTable = ({ hasLastMileChannels, setStockLevelsBarcode }) => {
	const { shop, organisation } = useShop();
	const { inventory } = useInventory(organisation.id, shop.id);
	const handleInventoryRowClick = useHandleInventoryClick();

	return (
		<Table className={styles.mobileTable} role="table">
			<TableBody>
				{inventory &&
					inventory.map((inventory) => {
						const row = {
							...inventory,
							hidden: !inventory.enabled,
							edited: inventory.productSource === 'myshop',
							quantity: inventory.quantity_i,
							hasIssues: inventory.issues?.length > 0,
							delivery_channels: hasLastMileChannels ? inventory.delivery_channels : []
						};
						return (
							<TableRow
								onClick={() => handleInventoryRowClick(row.barcode)}
								key={row.barcode}
								data-testid="inventory-table-row__mobile"
							>
								<MobileCell row={row} setStockLevelsBarcode={setStockLevelsBarcode} />
							</TableRow>
						);
					})}
			</TableBody>
		</Table>
	);
};

export default MobileTable;
